<template>
  <!-- background-color: #F4F5FA;  -->
  <v-fade-transition mode="out-in">
    <router-view style="font-family: 'Noto Sans KR', sans-serif;" />
  </v-fade-transition>
</template>

<script>
import '@/styles/overrides.sass'
export default {
  name: 'App',
};
</script>
